import { translator } from '@/i18n'
import { changelogMessages } from '@/i18n/messages/changelog'

export type AuditAction = 'create' | 'update' | 'delete'

export interface AuditRow {
  id: number
  occurredAt: string
  actorId: string
  actorName: string | null
  action: AuditAction
  entityType: string
  entityId: string
  field: string | null
  oldValue: string | null
  newValue: string | null
  detail: string | null
}

export interface AuditPage {
  rows: AuditRow[]
  total: number
  page: number
  pageSize: number
}

export interface AuditActor {
  id: string
  name: string | null
  edits: number
}

type ChangelogKey = keyof typeof changelogMessages.en

/** Friendly names (message keys) for the entity_type values the API records. */
export const ENTITY_LABELS: Record<string, ChangelogKey> = {
  session: 'entitySession',
  project: 'entityProject',
  rtk_segment: 'entityRtkSegment',
  project_request: 'entityProjectRequest',
  bonus_config: 'entityBonusConfig',
}

/** Translated at call time (render), so it follows the current language. */
export function entityLabel(type: string): string {
  const key = ENTITY_LABELS[type]
  return key ? translator(changelogMessages)(key) : type
}

/** Message keys for the audit actions; an unknown action shows as recorded. */
export const ACTION_LABELS: Record<string, ChangelogKey> = {
  create: 'actionCreate',
  update: 'actionUpdate',
  delete: 'actionDelete',
}

export function actionLabel(action: string): string {
  const key = ACTION_LABELS[action]
  return key ? translator(changelogMessages)(key) : action
}
